import emitter from 'scripts/utils/emitter'
import tryAddToCart from 'scripts/utils/cart/addToCart'

import { PurchaseButtons } from 'catalog/pages/NewProduct/type'

import Visual from './Visual'

export type Props = {
  purchaseButtons: PurchaseButtons
  regionId: string
  productId: number
  skuId: string
  productPackingCount: number
}

const ButtonsSection = (props: Props) => {
  const {
    purchaseButtons,
    regionId,
    productId,
    productPackingCount,
    skuId
  } = props
  const { assistedSale, pickupInStore, ecommerce } = purchaseButtons
  const isSingleButton = !pickupInStore || !ecommerce

  const addDeliveryProductToCart = (): void => {
    tryAddToCart({
      regionId: regionId,
      type: 'delivery',
      products: [
        {
          id: productId,
          quantity: productPackingCount + 1,
          skuId: skuId
        }
      ],
      override: true
    })
  }

  return (
    <Visual
      shouldShowAssistedSaleButton={assistedSale}
      shouldShowEcommerceButton={ecommerce}
      shouldShowPickupInStoreButton={pickupInStore}
      isSingleGrid={isSingleButton}
      addDeliveryProductToCart={addDeliveryProductToCart}
      showStockInfo={() => {
        emitter.emit('showStock')
      }}
    />
  )
}

export default ButtonsSection
